import React, { useEffect, useRef, useState } from 'react';
import PageTitle from '../components/layout/PageTitle';
import styled from 'styled-components';
import VideoPlayer from '../components/VideoPlayer';
import { PageContent, SideBar, SideBarTitle } from '../components/layout/style';
import SquidexRepository from '../service/SquidexRepository';
import VkLink from '../components/layout/VkLink';
import YoutubeLink from '../components/layout/YoutubeLink';

export const PersonBlock = styled.div`
    padding-bottom: 24px;
`;

export const PersonName = styled.h4`
    font-family: 'Ruslan Display', cursive;
    padding: 0 0 8px 0;
    margin: 0;
`;

export const PersonDescription = styled.div`
`;

export const PersonImage = styled.img`
    max-width: 400px;
    
    @media (max-width: 768px) {
        max-width: 350px;
    }
    
    @media (max-width: 360px) {
        max-width: 100%;
    }
`;

export const TitleBlock = styled.div`
    position: relative;
    padding-bottom: 24px;
    
    @media (min-width: 768px) {
        display: grid;
        grid-template-columns: 400px 1fr;
        grid-column-gap: 16px;
    }
`;

export const IconsBlock = styled.div`
`;

export const PhotoSourceBlock = styled.div`
    color: #777;
    font-size: 11px;
`;

export const EmptyList = styled.div`
    color: #777;
    text-align: center;
    padding: 32px;
`;

export default function MusiciansPage({ musicians = [] }) {

    const defaultVideoPlayerWidth = 360;
    const sideBarRef = useRef();

    const [sideBarWidth, setSideBarWidth] = useState(null);

    useEffect(() => {
        setSideBarWidth(sideBarRef.current.clientWidth);
    }, []);

    const videos = musicians
        .filter((musician) => !!musician.video)
        .map((musician) => musician.video.iv);

    return <>
        <PageContent>
            <PageTitle title='Музыка'/>
            {musicians.length <= 0 && <EmptyList>Ничего не найдено(</EmptyList>}

            {musicians.map((musician, key) => {
                return <PersonBlock key={`musician-${key}`}>
                    <PersonName>{musician.name.iv}</PersonName>
                    <TitleBlock>
                        <div>
                            <PersonImage src={musician.photo} alt={musician.name.iv}/>
                            <PhotoSourceBlock>
                                источник фото: <a href={musician.photoSource.iv} rel='noopener noreferrer' target='_blank'>{musician.photoSourceName.iv}</a>
                            </PhotoSourceBlock>
                        </div>
                        <div>
                            <PersonDescription dangerouslySetInnerHTML={{ __html: musician.lead.iv }}/>
                            <IconsBlock>
                                {musician.vkUrl.iv && <VkLink href={musician.vkUrl.iv}/>}
                                {musician.youtubeUrl && <YoutubeLink
                                    href={musician.youtubeUrl.iv}
                                    title={musician.youtubeUrlTitle ? musician.youtubeUrlTitle.iv : undefined
                                    }/>}
                            </IconsBlock>
                        </div>
                    </TitleBlock>
                </PersonBlock>
            })}
        </PageContent>
        <SideBar ref={sideBarRef}>
            <SideBarTitle>Видео</SideBarTitle>
            {videos.map((videoId, key) => <VideoPlayer
                width={sideBarWidth && sideBarWidth < defaultVideoPlayerWidth ? sideBarWidth : defaultVideoPlayerWidth}
                key={`video-${key}`}
                videoId={videoId}/>)
            }
        </SideBar>
    </>
}

MusiciansPage.getInitialProps = async (context) => {
    const musicians = await SquidexRepository.getMusicians(context);

    return {
        musicians,
    };
};
